//  Notification received while app in background: OS/Firebase will intercept
//  and show in notification center.  If user clicks notification, opens app to
//  click_action URL.
//
//  Notification received while app in foreground: added to store, and should
//  show notification in app.  If user clicks notification, redirect to
//  click_action URL.

import * as UI     from '../ui';
import { connect } from 'react-redux';
import React       from 'react';


class Notification extends React.PureComponent {

  constructor(props) {
    super(props);
    this.app = null;
  }

  componentDidMount() {
    this.$f7ready(app => {
      this.app = app;

      if (hasNotification(this.props))
        this.showNotification();
    });
  }

  componentDidUpdate(prevProps) {
    if (hasNotification(this.props))
      this.showNotification();
    else if (hasNotification(prevProps))
      this.closeNotification();

  }

  navigateTo(url) {
    const path = this.relativeURL(url);
    this.app.views.main.router.navigate(path);
  }

  relativeURL(url) {
    const routerParams = this.app.views.main.router.params;
    if (routerParams.pushStateSeparator)
      return url.split(routerParams.pushStateSeparator)[1];
    else if (routerParams.pushStateRoot)
      return url.replace(routerParams.pushStateRoot, '');
    else
      return null;
  }

  showNotification() {
    if (!this.app)
      return;

    const { title }             = this.props;
    const { body }              = this.props;
    const { url }               = this.props;
    const { cleanNotification } = this.props;

    const notification = this.app.notification.create({
      title,
      text:        body,
      closeButton: true
    });
    notification.on('click', () => {
      cleanNotification();
      if (url)
        this.navigateTo(url);
    });
    notification.on('close', cleanNotification);
    notification.open();
    playNotificationSound();
  }

  closeNotification() {
    if (!this.app)
      return;

    this.app.notification.close();
  }

  render() {
    return null;
  }
}


function hasNotification(notification) {
  const { title } = notification;
  const { body }  = notification;
  const { url }   = notification;

  return title || body || url;
}

async function playNotificationSound() {
  const audioFile = 'audio/exclamation.mp3';

  // navigator.notification.beep() doesn't work on iOS
  const isAndroid = (window.device && window.device.platform === 'Android');
  const isiOS     = (window.device && window.device.platform === 'iOS');
  if (isAndroid)
    navigator.notification.beep();
  else if (isiOS) {
    await new Promise((resolve, reject) => {
      const media = new window.Media(audioFile, resolve, reject);
      media.play();
    });
  } else if ('Audio' in window) {
    const audio = new Audio(`/${audioFile}`);
    try {
      await audio.play();
    } catch (error) {
      // Autoplay may not work before user interacts with the page.
      // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
    }
  }
}


export default connect(
  state => ({
    ...UI.getNotification(state)
  }),
  dispatch => ({
    cleanNotification: () => dispatch(UI.setNotification(null))
  })
)(Notification);
